/**
 * Icon mapping for tool configurations
 * Maps icon name strings from backend to Lucide React components
 */
import {
  Pencil,
  Type,
  FileText,
  List,
  Lightbulb,
  Quote,
  SquareStack,
  Network,
  HelpCircle,
  AlignLeft,
  PenTool,
  FileEdit,
  Layers,
  BookMarked,
  ListOrdered,
  Twitter,
  Linkedin,
  Video,
  Instagram,
  Mail,
  Mic,
  Clock,
  Brain,
  BookOpen,
  LucideIcon,
  Search,
  Target,
  TrendingUp,
  Users,
  Bot,
  Columns,
  Briefcase,
  GraduationCap,
} from "lucide-react"

export const iconMap: Record<string, LucideIcon> = {
  Pencil,
  Type,
  FileText,
  List,
  Lightbulb,
  Quote,
  SquareStack,
  Network,
  HelpCircle,
  AlignLeft,
  PenTool,
  FileEdit,
  Layers,
  BookMarked,
  ListOrdered,
  Twitter,
  Linkedin,
  Video,
  Instagram,
  Mail,
  Mic,
  Clock,
  Brain,
  BookOpen,
  Search,
  Target,
  TrendingUp,
  Users,
  Bot,
  Columns,
  Briefcase,
  GraduationCap,
}

/**
 * Get Lucide icon component by name
 * Returns FileText as fallback if icon not found
 */
export function getIconByName(iconName: string): LucideIcon {
  return iconMap[iconName] || FileText
}
